import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo.svg'
import Services from '../../api/service';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './style.css';


const Footer = (props) => {
    const { t } = useTranslation();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="logo" loading="lazy" decoding="async" />
                                </div>
                                <p className="text-left">{t('footer.description')}</p>
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/anas.ar.learning" target="_blank" rel="noopener noreferrer">
                                            <FaFacebookF />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/@Learningarabic.online" target="_blank" rel="noopener noreferrer">
                                            <FaYoutube />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/anas.learn.arabic" target="_blank" rel="noopener noreferrer">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.quickLinks')}</h3>
                                </div>
                                <ul>
                                    <li><a onClick={ClickHandler} href="#hero">{t('home')}</a></li>
                                    <li><a onClick={ClickHandler} href="#about">{t('aboutNav')}</a></li>
                                    <li><a onClick={ClickHandler} href="#features">{t('featuresNav')}</a></li>
                                    <li><a onClick={ClickHandler} href="#level-test">{t('assessment')}</a></li>
                                    <li><a onClick={ClickHandler} href="#contact">{t('contact')}</a></li>
                                    <li><Link onClick={ClickHandler} to="/become-partner">{t('becomePartner.title')}</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.contact')}</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-placeholder"></i>{t('footer.tunisiaAddress')}</li>
                                        <li><i className="fi flaticon-placeholder"></i>{t('footer.franceAddress')}</li>
                                        <li><i className="fi flaticon-phone-call"></i><span>{t('footer.tunisiaLabel')} </span><span dir="ltr">{t('footer.tunisiaPhone')}</span></li>
                                        <li><i className="fi flaticon-phone-call"></i><span>{t('footer.franceLabel')} </span><span dir="ltr">{t('footer.francePhone')}</span></li>
                                        <li><i className="fi flaticon-email"></i>{t('footer.email')}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <p className="copyright">{t('footer.copyright')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;